// StatusSelect.jsx
// Client: vmfive
// Version: 1.0.0
// Inline status switcher — pill-shaped select that changes color by value

import React from 'react';
import './StatusSelect.css';

const STATUS_CONFIG = {
  draft: 'status-select--draft',
  active: 'status-select--active',
  paused: 'status-select--paused',
  archived: 'status-select--archived',
};

// disabledOptions: array of { value: string, tooltip?: string }
// Options whose value matches will be rendered as disabled.
// The first matching tooltip is shown on the wrapper when hovering.
export default function StatusSelect({
  value,
  options = [],
  onChange,
  disabled = false,
  className = '',
  disabledOptions = [],
}) {
  const statusClass = STATUS_CONFIG[value?.toLowerCase()] || '';

  // Build a lookup map: value → tooltip string (or true if no tooltip)
  const disabledMap = {};
  let wrapperTooltip = '';
  for (const d of disabledOptions) {
    const dv = typeof d === 'string' ? d : d.value;
    const dt = typeof d === 'string' ? '' : (d.tooltip || '');
    disabledMap[dv] = true;
    if (!wrapperTooltip && dt) wrapperTooltip = dt;
  }

  const select = (
    <select
      className={`status-select ${statusClass} ${className}`}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onClick={(e) => e.stopPropagation()}
    >
      {options.map((opt) => {
        const optValue = typeof opt === 'string' ? opt : opt.value;
        const optLabel = typeof opt === 'string' ? opt : opt.label;
        return (
          <option key={optValue} value={optValue} disabled={!!disabledMap[optValue]}>
            {optLabel}
          </option>
        );
      })}
    </select>
  );

  if (wrapperTooltip) {
    return (
      <span title={wrapperTooltip} style={{ display: 'inline-block' }}>
        {select}
      </span>
    );
  }

  return select;
}
